import { useClickOutside } from "@/lib/hooks/useClickOutside";
import { useEffect, useRef } from "react";
import Accordion, { AccordionProps } from "./Accordion/Accordion";
import Footer from "./Footer";
import Header from "./Header";
import { Container, Wrapper } from "./styles";
import ClientCSSTransition from "@/lib/components/ClientCSSTransition";
import {
  enableBodyScroll,
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";

export type FiltersProps = {
  className?: string;
  handleClose: () => void;
  isOpen: boolean;
  totalHits: number;
  groups: AccordionProps["groups"];
};

const Filters: React.FC<FiltersProps> = (props) => {
  const { className, totalHits, handleClose, isOpen, groups } = props;

  const wrapperRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const accordionRef = useRef<HTMLDivElement>(null);

  useClickOutside(containerRef, handleClose);

  useEffect(() => {
    const accordion = accordionRef.current;
    if (!accordion) return;

    if (isOpen) {
      disableBodyScroll(accordion);
    } else {
      enableBodyScroll(accordion);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpen]);

  return (
    <ClientCSSTransition
      classNames="animation"
      nodeRef={wrapperRef}
      addEndListener={(done) => {
        wrapperRef.current?.addEventListener("transitionend", done, false);
      }}
      in={isOpen}
      mountOnEnter
      unmountOnExit
    >
      <Wrapper ref={wrapperRef} className={className}>
        <Container ref={containerRef}>
          <Header handleClose={handleClose} />
          <Accordion groups={groups} ref={accordionRef} />
          <Footer handleClose={handleClose} totalHits={totalHits} />
        </Container>
      </Wrapper>
    </ClientCSSTransition>
  );
};

export default Filters;
